<template>
	<div class="paper_main">
		<div class="navdiv">
			<ul style="list-style: none;min-height: 56px;">
				<li class="step_li">
					<div class="num_container" :class="{'active':bgcolor==1}"><span class="num">1</span></div>
					<div class="title_container" :class="{'active2':bgcolor==1}">Abstract content</div>
				</li>
				<li class="step_li">
					<div class="num_container" :class="{'active':bgcolor==2}"><span class="num">2</span></div>
					<div class="title_container" :class="{'active2':bgcolor==2}">Authers infomation</div>
				</li>
				<li class="step_li">
					<div class="num_container" :class="{'active':bgcolor==3}"><span class="num">3</span></div>
					<div class="title_container" :class="{'active2':bgcolor==3}">Abstract preview</div>
				</li>
				<li class="step_li">
					<div class="num_container" :class="{'active':bgcolor==4}"><span class="num">4</span></div>
					<div class="title_container" :class="{'active2':bgcolor==4}">Abstract submitted successfully</div>
				</li>
			</ul>
		</div>
		<router-view></router-view>
	</div>
</template>
<script>
  import Bus from '@/bus'
	export default {
		data() {
				return {
				    bgcolor:'1',
        }
			},
			props: {},
			methods: {

      },

			mounted() {
        Bus.$on('button', index => {
          console.log(index)
          this.bgcolor=index;
          console.log(this.bgcolor)

        });
//        Bus.$on('button',aa)
      }
	}
</script>
<style scoped>
	.paper_main {
		color: #000000;
		width: 1200px;
		font-size: 15px;
		margin: 0px auto;
		min-height: 20px;
    margin: 90px auto -40px;
    padding: 5px;
	}

	.navdiv {
		width: 100%;
		margin: auto;
		overflow: hidden;
		min-height: 56px;
	}

	.num {
		font-size: 20px;
		color: #FFFFFF;
		line-height: 56px;
	}

	.num_container {
		width: 56px;
		height: 56px;
		background-color: #c9c9c9;
		border-radius: 50%;
		text-align: center;
		float: left;
	}

.active{
  background: #f39800;
}


	.step_li {
		width: 296px;
		display: inline;
		border-bottom: 1px solid red;
	}

	.title_container {
		line-height: 56px;
		width: 240px;
		float: left;
    text-align: center;
		border-bottom: 3px #C9C9C9 solid;
	}
  .active2{
    border-bottom: 3px solid #f39800;
  }


</style>



// WEBPACK FOOTER //
// paper_index.vue?7270c422